import { render, staticRenderFns } from "./ScoresList.vue?vue&type=template&id=499de4b5"
import script from "./ScoresList.vue?vue&type=script&lang=js"
export * from "./ScoresList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports